module.exports = __webpack_public_path__ + "img/1.96c827c5.jpg";